import { createContext, useContext } from 'react'

/**
 * Where a Field puts its label (ADR 0020):
 * - `top`: above the control (the default);
 * - `floating`: inside the control, floating onto its top border when the
 *   field is focused or filled, as react-admin's inputs do; it saves a line;
 * - `inline`: beside the control, in a column shared with sibling fields.
 *   Below `tablet` it falls back to `top`.
 */
export type LabelPlacement = 'top' | 'floating' | 'inline'

/** Set by FilterBar and FormGrid for every Field inside; a Field's own prop wins. */
export const LabelPlacementContext = createContext<LabelPlacement>('top')

export function useLabelPlacement(own: LabelPlacement | undefined): LabelPlacement {
  const inherited = useContext(LabelPlacementContext)
  return own ?? inherited
}
